export type NewsSource = {
  id: string;
  name: string;
  url: string;
};

export const ALL_NEWS_SOURCES: NewsSource[] = [
  { id: 'nytimes', name: 'The New York Times', url: 'https://www.nytimes.com/international/' },
  { id: 'wapo', name: 'The Washington Post', url: 'https://www.washingtonpost.com/world/' },
  { id: 'ap', name: 'Associated Press', url: 'https://apnews.com/hub/politics' },
  { id: 'lemonde', name: 'Le Monde', url: 'https://www.lemonde.fr/international/' },
  { id: 'afp', name: 'Agence France Presse (AFP)', url: 'https://www.afp.com/fr' },
  { id: 'france24', name: 'France 24', url: 'https://www.france24.com/fr/' },
  { id: 'ouestfrance', name: 'Ouest France', url: 'https://www.ouest-france.fr/monde/' },
];
